import React, { useContext, useState, useEffect } from "react";

import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import FormHelperText from "@material-ui/core/FormHelperText";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";

import SpeedIcon from "@material-ui/icons/Speed";
import GroupIcon from "@material-ui/icons/Group";
import AssignmentIcon from "@material-ui/icons/Assignment";
import PersonIcon from "@material-ui/icons/Person";
import CallIcon from "@material-ui/icons/Call";
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import ForumIcon from "@material-ui/icons/Forum";
import FilterListIcon from "@material-ui/icons/FilterList";
import ClearIcon from "@material-ui/icons/Clear";
import SendIcon from '@material-ui/icons/Send';
import MessageIcon from '@material-ui/icons/Message';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import TimerIcon from '@material-ui/icons/Timer';

import { makeStyles } from "@material-ui/core/styles";
import { grey, blue } from "@material-ui/core/colors";
import { toast } from "react-toastify";

import Chart from "./Chart";
import ButtonWithSpinner from "../../components/ButtonWithSpinner";

import CardCounter from "../../components/Dashboard/CardCounter";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import { AuthContext } from "../../context/Auth/AuthContext";

import useDashboard from "../../hooks/useDashboard";
import useNoInteractionClosures from "../../hooks/useNoInteractionClosures";
import { i18n } from "../../translate/i18n";
import useTickets from "../../hooks/useTickets";
import useUsers from "../../hooks/useUsers";
import useMessages from "../../hooks/useMessages";
import { ChatsUser } from "./ChartsUser"
import { ChartsPeakHours } from "./ChartsPeakHours";
import { ChartsPeakDays } from "./ChartsPeakDays";
import { ChartsPeakWeekDays } from "./ChartsPeakWeekDays";
import { ChartsMessagesByUser } from "./ChartsMessagesByUser";
import { ChartsMessagesPeakDays } from "./ChartsMessagesPeakDays";
import { ChartsConvertedTickets } from "./ChartsConvertedTickets";
import { ChartsClosedWithoutInteraction } from "./ChartsClosedWithoutInteraction";
import { ChartsTicketsByContactTag } from "./ChartsTicketsByContactTag";

import Filters from "./Filters";
import { isEmpty } from "lodash";
import moment from "moment";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.padding,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(2),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
  iframeDashboard: {
    width: "100%",
    height: "calc(100vh - 64px)",
    border: "none",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: 240,
  },
  customFixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  customFixedHeightPaperLg: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  card1: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: "palette",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card2: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: "palette",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card3: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
  //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card4: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card5: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card6: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card7: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card8: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  card9: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    height: "100%",
    //backgroundColor: theme.palette.primary.main,
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.boxticket.main : theme.palette.primary.main,
    color: "#eee",
  },
  fixedHeightPaper2: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const [counters, setCounters] = useState({
    supportHappening: 0,
    supportPending: 0,
    supportFinished: 0,
    avgSupportTime: 0,
    avgWaitTime: 0,
    leads: 0,
  });
  const [attendants, setAttendants] = useState([]);
  const [dateFrom, setDateFrom] = useState(moment("1", "D").format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);
  const { find } = useDashboard();
  // Métrica de chamados finalizados sem interação (somente admin: endpoint restrito)
  const { find: findNoInteraction } = useNoInteractionClosures();
  const [noInteraction, setNoInteraction] = useState({ total: 0, byUser: [] });

  let newDate = new Date();
  let date = newDate.getDate();
  let month = newDate.getMonth() + 1;
  let year = newDate.getFullYear();
  let now = `${year}-${month < 10 ? `0${month}` : `${month}`}-${date < 10 ? `0${date}` : `${date}`}`;

  const [showFilter, setShowFilter] = useState(false);
  const [queueTicket, setQueueTicket] = useState(false);
  // Motivo: forcar o rebusca de todos os graficos ao clicar em "Atualizar",
  // mesmo quando o intervalo de datas nao muda. Ao incrementar essa chave os
  // graficos remontam e refazem suas requisicoes com os dados mais atuais.
  const [refreshKey, setRefreshKey] = useState(0);

  const getEffectiveDateRange = () => {
    if (
      !isEmpty(dateFrom) &&
      !isEmpty(dateTo) &&
      moment(dateFrom).isValid() &&
      moment(dateTo).isValid()
    ) {
      return {
        initialDate: moment(dateFrom).format("YYYY-MM-DD"),
        finalDate: moment(dateTo).format("YYYY-MM-DD"),
      };
    }

    return {
      initialDate: moment("1", "D").format("YYYY-MM-DD"),
      finalDate: moment().format("YYYY-MM-DD"),
    };
  };

  const { initialDate: globalInitialDate, finalDate: globalFinalDate } = getEffectiveDateRange();

  const { user } = useContext(AuthContext);
  var userQueueIds = [];

  if (user.queues && user.queues.length > 0) {
    userQueueIds = user.queues.map((q) => q.id);
  }

  useEffect(() => {
    if (
      isEmpty(dateFrom) ||
      isEmpty(dateTo) ||
      !moment(dateFrom).isValid() ||
      !moment(dateTo).isValid()
    ) {
      return;
    }

    const debounce = setTimeout(() => {
      fetchData();
    }, 250);

    return () => clearTimeout(debounce);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dateFrom, dateTo]);

  async function fetchData() {
    setLoading(true);

    const params = {
      date_from: moment(dateFrom).format("YYYY-MM-DD"),
      date_to: moment(dateTo).format("YYYY-MM-DD"),
    };

    if (!moment(dateFrom).isValid() || !moment(dateTo).isValid()) {
      toast.error(i18n.t("dashboard.filters.invalid"));
      setLoading(false);
      return;
    }

    try {
      const data = await find(params);

      setCounters((prevCounters) => ({
        ...prevCounters,
        ...(data?.counters || {}),
      }));

      if (isArray(data?.attendants)) {
        setAttendants(data.attendants);
      } else {
        setAttendants([]);
      }
    } catch (err) {
      toastError(err);
      setAttendants([]);
    } finally {
      setLoading(false);
    }

    // Endpoint restrito a admin; para os demais o bloco nem é exibido.
    if (user?.profile === "admin") {
      try {
        const { initialDate, finalDate } = getEffectiveDateRange();
        const noInteractionData = await findNoInteraction({ initialDate, finalDate });
        setNoInteraction({
          total: noInteractionData?.total || 0,
          byUser: isArray(noInteractionData?.byUser) ? noInteractionData.byUser : [],
        });
      } catch (err) {
        setNoInteraction({ total: 0, byUser: [] });
      }
    }
  }

  // Motivo: o botao "Atualizar" deve rebuscar TODOS os dados com o intervalo
  // atual, mesmo quando as datas nao mudaram. fetchData rebusca contadores e
  // atendentes; incrementar refreshKey remonta os graficos, forcando cada um a
  // refazer sua requisicao com os dados mais atuais.
  const handleRefresh = () => {
    fetchData();
    setRefreshKey((prev) => prev + 1);
  };

  function formatTime(minutes) {
    if (!Number.isFinite(Number(minutes))) {
      return "00h 00m";
    }

    return moment()
      .startOf("day")
      .add(Number(minutes), "minutes")
      .format("HH[h] mm[m]");
  }

  const GetUsers = () => {
    let count;
    let userOnline = 0;
    attendants.forEach(user => {
      if (user.online === true) {
        userOnline = userOnline + 1
      }
    })
    count = userOnline === 0 ? 0 : userOnline;
    return count;
  };

  return (
    <div>
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3} justifyContent="flex-end">

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label={i18n.t("common.startDate")}
              type="date"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
              className={classes.fullWidth}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3}>
            <TextField
              label={i18n.t("common.endDate")}
              type="date"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
              className={classes.fullWidth}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6} className={classes.alignRight}>
            <ButtonWithSpinner
              loading={loading}
              onClick={handleRefresh}
              variant="contained"
              color="primary"
            >
              {i18n.t("common.refresh")}
            </ButtonWithSpinner>
          </Grid>

          {/* Data: 05/10/2026 | Motivo: "Dias de Atendimentos" passou a ser o primeiro grafico
              do Dashboard, a pedido (antes ficava abaixo do grafico de horarios). */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChartsPeakDays key={`peakdays-${refreshKey}`} initialDate={globalInitialDate} finalDate={globalFinalDate} />
            </Paper>
          </Grid>

          {/* Autor: GitHub Copilot | Data: 28/03/2026 | Motivo: exibir primeiro
              o grafico de total de conversas por usuario na pagina inicial. */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChatsUser key={`chatsuser-${refreshKey}`} initialDate={globalInitialDate} finalDate={globalFinalDate} />
            </Paper>
          </Grid>

          {/* Motivo: grafico do total de mensagens da empresa por dia do mes (mesmo formato de dias de atendimentos). */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChartsMessagesPeakDays key={`messagespeakdays-${refreshKey}`} initialDate={globalInitialDate} finalDate={globalFinalDate} />
            </Paper>
          </Grid>

          {/* Motivo: grafico de mensagens por usuario (recebidas x enviadas) respeitando o filtro de datas. */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChartsMessagesByUser key={`messagesbyuser-${refreshKey}`} initialDate={globalInitialDate} finalDate={globalFinalDate} />
            </Paper>
          </Grid>

          {/* Motivo: chamados abertos no periodo por tag do contato (ContactTags); contagens para todos,
              lista de chamados ("Ver") so para admin. So aparece quando algum chamado tem contato com tag. */}
          <ChartsTicketsByContactTag
            key={`ticketsbycontacttag-${refreshKey}`}
            initialDate={globalInitialDate}
            finalDate={globalFinalDate}
            isAdmin={user?.profile === "admin"}
            paperClass={classes.fixedHeightPaper2}
          />

          {/* Motivo: chamados finalizados sem o atendente ter interagido com o contato,
              por atendente, com detalhamento dos tickets. Dado gerencial: só admin. */}
          {user?.profile === "admin" && (
            <Grid item xs={12}>
              <Paper className={classes.fixedHeightPaper2}>
                <ChartsClosedWithoutInteraction
                  key={`nointeraction-${refreshKey}`}
                  byUser={noInteraction.byUser}
                  initialDate={globalInitialDate}
                  finalDate={globalFinalDate}
                />
              </Paper>
            </Grid>
          )}

          {/* Motivo: grafico de conversoes (Sim x Nao) com totais e percentual; so aparece quando ha dados no periodo. */}
          <ChartsConvertedTickets
            key={`convertedtickets-${refreshKey}`}
            initialDate={globalInitialDate}
            finalDate={globalFinalDate}
            paperClass={classes.fixedHeightPaper2}
          />

          {/* Data: 02/04/2026 | Motivo: adicionar gráfico de picos por horario abaixo do total por usuarios. */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChartsPeakHours key={`peakhours-${refreshKey}`} initialDate={globalInitialDate} finalDate={globalFinalDate} />
            </Paper>
          </Grid>

          {/* Autor: GitHub Copilot | Data: 23/04/2026 | Motivo: adicionar grafico para distribuicao semanal dos atendimentos. */}
          <Grid item xs={12}>
            <Paper className={classes.fixedHeightPaper2}>
              <ChartsPeakWeekDays key={`peakweekdays-${refreshKey}`} initialDate={globalInitialDate} finalDate={globalFinalDate} />
            </Paper>
          </Grid>
		

          {/* EM ATENDIMENTO */}
          <Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card1}
              style={{ overflow: "hidden" }}
              elevation={4}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    {i18n.t("dashboard.cards.inConversation")}
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {counters.supportHappening}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={2}>
                  <CallIcon
                    style={{
                      fontSize: 100,
                      color: "#FFFFFF",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* AGUARDANDO */}
          <Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card2}
              style={{ overflow: "hidden" }}
              elevation={6}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    {i18n.t("dashboard.cards.waiting")}
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {counters.supportPending}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <HourglassEmptyIcon
                    style={{
                      fontSize: 100,
                      color: "#FFFFFF",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* ATENDENTES ATIVOS */}
			  {/*<Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card6}
              style={{ overflow: "hidden" }}
              elevation={6}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    Conversas Ativas
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {GetUsers()}
                      <span
                        style={{ color: "#805753" }}
                      >
                        /{attendants.length}
                      </span>
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <RecordVoiceOverIcon
                    style={{
                      fontSize: 100,
                      color: "#805753",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
</Grid>*/}

          {/* FINALIZADOS */}
          <Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card3}
              style={{ overflow: "hidden" }}
              elevation={6}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    {i18n.t("dashboard.cards.finished")}
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {counters.supportFinished}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <CheckCircleIcon
                    style={{
                      fontSize: 100,
                      color: "#FFFFFF",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* FINALIZADOS SEM INTERAÇÃO */}
          {user?.profile === "admin" && (
            <Grid item xs={12} sm={6} md={4}>
              <Paper
                className={classes.card3}
                style={{ overflow: "hidden" }}
                elevation={6}
              >
                <Grid container spacing={3}>
                  <Grid item xs={8}>
                    <Typography
                      component="h3"
                      variant="h6"
                      paragraph
                    >
                      {i18n.t("dashboard.noInteraction.cardTitle")}
                    </Typography>
                    <Grid item>
                      <Typography
                        component="h1"
                        variant="h4"
                      >
                        {noInteraction.total}
                      </Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={4}>
                    <ErrorOutlineIcon
                      style={{
                        fontSize: 100,
                        color: "#FFFFFF",
                      }}
                    />
                  </Grid>
                </Grid>
              </Paper>
            </Grid>
          )}

          {/* NOVOS CONTATOS */}
          <Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card4}
              style={{ overflow: "hidden" }}
              elevation={6}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    {i18n.t("dashboard.cards.newContacts")}
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {counters.leads || 0}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <GroupAddIcon
                    style={{
                      fontSize: 100,
                      color: "#FFFFFF",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          
          {/* MEDIANA DE ATENDIMENTO */}
          <Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card8}
              style={{ overflow: "hidden" }}
              elevation={6}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    {i18n.t("dashboard.cards.medianConversation")}
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {formatTime(counters.avgSupportTime)}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <AccessAlarmIcon
                    style={{
                      fontSize: 100,
                      color: "#FFFFFF",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          {/* MEDIANA DE ESPERA */}
          <Grid item xs={12} sm={6} md={4}>
            <Paper
              className={classes.card9}
              style={{ overflow: "hidden" }}
              elevation={6}
            >
              <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Typography
                    component="h3"
                    variant="h6"
                    paragraph
                  >
                    {i18n.t("dashboard.cards.medianWait")}
                  </Typography>
                  <Grid item>
                    <Typography
                      component="h1"
                      variant="h4"
                    >
                      {formatTime(counters.avgWaitTime)}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <TimerIcon
                    style={{
                      fontSize: 100,
                      color: "#FFFFFF",
                    }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
		  
          {/* USUARIOS ONLINE */}
          <Grid item xs={12}>
            {attendants.length ? (
              <TableAttendantsStatus
                attendants={attendants}
                loading={loading}
              />
            ) : null}
          </Grid>

        </Grid>
      </Container >
    </div >
  );
};

export default Dashboard;
